import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-request',
  templateUrl: './detail-request.component.html',
  styleUrls: ['./detail-request.component.scss']
})
export class DetailRequestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
